import { useQuery } from "react-query";

import { fetchUserEmailSettings } from "@pages/settings/api";

export const useUserEmailSettings = () => {
  return useQuery(["email"], async () => await fetchUserEmailSettings());
};
